const toBase64FromBytes = (bytes) => {
  if (!Array.isArray(bytes) || bytes.length === 0) return null;

  let binary = '';
  for (let i = 0; i < bytes.length; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }

  if (typeof window !== 'undefined' && typeof window.btoa === 'function') {
    return window.btoa(binary);
  }

  return null;
};

const resolveRelativeAvatarUrl = (value) => {
  const baseUrl = process.env.REACT_APP_URL || (typeof window !== 'undefined' ? window.location.origin : '');
  if (!baseUrl) return value;

  try {
    return new URL(value, baseUrl).toString();
  } catch {
    return value;
  }
};

const resolveStringAvatar = (value) => {
  const trimmedAvatar = value.trim();
  if (!trimmedAvatar) return null;

  if (trimmedAvatar.startsWith('data:image/')) return trimmedAvatar;
  if (/^https?:\/\//i.test(trimmedAvatar)) return trimmedAvatar;
  if (/^blob:/i.test(trimmedAvatar)) return trimmedAvatar;
  if (trimmedAvatar.startsWith('/')) return resolveRelativeAvatarUrl(trimmedAvatar);
  if (/^(uploads?|images?)\//i.test(trimmedAvatar)) return resolveRelativeAvatarUrl(trimmedAvatar);

  const looksLikeObjectId = /^[a-f0-9]{24}$/i.test(trimmedAvatar);
  if (looksLikeObjectId) return null;

  return `data:image/png;base64,${trimmedAvatar}`;
};

export const resolveAvatarSrc = (avatar) => {
  if (!avatar) return null;

  if (typeof avatar === 'string') {
    return resolveStringAvatar(avatar);
  }

  if (avatar instanceof Uint8Array) {
    const base64 = toBase64FromBytes(Array.from(avatar));
    return base64 ? `data:image/png;base64,${base64}` : null;
  }

  if (avatar instanceof ArrayBuffer) {
    const base64 = toBase64FromBytes(Array.from(new Uint8Array(avatar)));
    return base64 ? `data:image/png;base64,${base64}` : null;
  }

  if (typeof avatar === 'object') {
    const nestedString = [
      avatar.avatarUrl,
      avatar.avatar,
      avatar.url,
      avatar.src,
    ].find((candidate) => typeof candidate === 'string' && candidate.trim());

    if (nestedString) {
      return resolveStringAvatar(nestedString);
    }

    const bufferData = avatar?.type === 'Buffer' ? avatar?.data : null;
    const base64 = toBase64FromBytes(bufferData);
    return base64 ? `data:image/png;base64,${base64}` : null;
  }

  return null;
};

export const getInitialsFromName = (firstName, lastName, fallback = '') => {
  const first = String(firstName || '').trim();
  const last = String(lastName || '').trim();

  const initials = `${first.charAt(0)}${last.charAt(0)}`.trim().toUpperCase();
  if (initials) return initials;
  if (first) return first.charAt(0).toUpperCase();
  if (last) return last.charAt(0).toUpperCase();

  const normalizedFallback = String(fallback || '').trim();
  return normalizedFallback ? normalizedFallback.charAt(0).toUpperCase() : '';
};

export const getUserInitials = (user, fallback = '') => getInitialsFromName(user?.firstName, user?.lastName, fallback);
